var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"titulo\">\r\n    <h2> <strong>Suscribite al Acceso Digital.</strong> Leé LA NACION sin límite de notas. </h2>            \r\n</div>   ";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Statics/scripts/paywall/views/partials/header/suscribite.hbs
// module id = 524
// module chunks = 0